import { pipe } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import FilterRooms from './FilterRooms'
import withReduxForm from './withReduxForm'
import withState from './withState'

export default pipe(
  withTranslation(),
  withReduxForm,
  withState,
)(FilterRooms) as any
